import React from "react";
import { EXP_ESTADO } from "@/constants/labels";

export function ExpEstadoBadge({ estado }) {
  const s = EXP_ESTADO[estado] || EXP_ESTADO.borrador;
  return <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${s.cls}`}>{s.label}</span>;
}

export function LockBanner() {
  return (
    <div className="mb-5 flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-800" data-testid="banner-bloqueado">
      <span className="font-semibold">Expediente enviado.</span>
      <span>Ya confirmaste y enviaste tu información a HUMAN. Para corregir un dato usa «Solicitar actualización de datos»: el cambio se aplicará cuando HUMAN lo apruebe.</span>
    </div>
  );
}
